import { render, staticRenderFns } from "./ModalTagFriends.vue?vue&type=template&id=edb71924&"
import script from "./ModalTagFriends.vue?vue&type=script&lang=js&"
export * from "./ModalTagFriends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports